import {styled} from '@mui/material';
import Icon from 'presentation/icons';

type StyledCopyIconProps = {
	$copied?: boolean;
};

const StyledCopyIcon = styled(Icon)<StyledCopyIconProps>`
	cursor: ${({$copied}) => ($copied ? 'default !important' : 'pointer')};
	color: ${({theme, $copied}) =>
		$copied ? theme.colors.light.success.main : theme.colors.brand.primary.blue};
`;

export {StyledCopyIcon};
export type {StyledCopyIconProps};
